import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useWorkspaceAuthority } from '@/contexts/WorkspaceAuthorityContext';
import { isValidWorkspaceIdFormat } from '@/lib/auth/workspaceAuthority';

export function parseWorkspaceIdFromPath(pathname: string): string | null {
  const match = pathname.match(/^\/workspaces\/([^/]+)(?:\/|$)/);
  if (!match?.[1]) return null;
  try {
    const candidate = decodeURIComponent(match[1]);
    return isValidWorkspaceIdFormat(candidate) ? candidate : null;
  } catch {
    return null;
  }
}

/**
 * Returns the validated workspace authority when available and otherwise the
 * canonical route scope. The route fallback is navigation context only; route
 * boundaries and server RLS remain authoritative for data access.
 */
export function useActiveWorkspaceId(): string | null {
  const location = useLocation();
  const { workspaceId, status } = useWorkspaceAuthority();
  const routeWorkspaceId = useMemo(
    () => parseWorkspaceIdFromPath(location.pathname),
    [location.pathname],
  );
  return status === 'ready' ? workspaceId : routeWorkspaceId;
}
